<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card class="pa-4 grey lighten-4" outlined elevation="5">
          <!-- <v-card-title class="text-h6 font-weight-bold">
            Contador de Visitas
          </v-card-title> -->
          <v-card-text>
            <div class="d-flex justify-center flex-wrap">
                Contador de visitas:
              <v-icon
                v-for="(digit, index) in numberIcons"
                :key="index"
                class="mx-1"
                size="60"
                color="gray"
              >
                {{ digit }}
              </v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import visitasService from "@/services/visitasService.js";

export default {
  name: "Visita",
  data() {
    return {
      totalVisitas: 0,
      errors: {},
    };
  },
  mounted() {
    

setTimeout(() => {
    this.getVisita();
  }, 1000); // espera 5000 ms = 5 segundos


  },
  methods: {
    getVisita() {
      visitasService.getVisita()
        .then((respuesta) => {
          this.totalVisitas = respuesta.data.cantidad;
         //this.totalVisitas = 1234567890;
          console.log(this.totalVisitas);
        })
        .catch((e) => {
          this.errors = e.response?.data?.errors || {};
          console.log(this.errors);
        });
    },
    getNumberIcons(number) {
      return String(number).split("").map(digit => `mdi-numeric-${digit}-box`);
    }
  },
  computed: {
    numberIcons() {
      return this.getNumberIcons(this.totalVisitas);
    }
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 16px;
}
</style>
